export const getEntityListForDropDown = (entityList, selectedEntity) => {
  const list = [];

  if (entityList?.length) {
    entityList.forEach(item => {
      const { EntityKey: entityKey, NameEnglish: name, Logo: image } = item;

      list.push({
        isSelected: entityKey === selectedEntity.entityKey,
        fieldValue: name,
        itemImage: image,
        value: entityKey,
        key: entityKey,
        extras: {
          entityKey,
          name,
          image,
        },
      });
    });
  }
  return list;
};
